import React from "react";
import Navbar from "../navbar/navbar-desktop.tsx";
import Footer from "../footer/footer.tsx";
import { Helmet } from "react-helmet";

const images = [
  "./img/akce-duo-jamaha/akce-duo-jamaha-6.jpg",
  "./img/akce-duo-jamaha/akce-duo-jamaha-7.jpg",
  "./img/akce-duo-jamaha/akce-duo-jamaha-3.jpg",
  "./img/akce-duo-jamaha/akce-duo-jamaha-4.jpg",
  "./img/akce-duo-jamaha/akce-duo-jamaha-5.jpg",
  "./img/akce-duo-jamaha/akce-duo-jamaha-1.jpg",
  "./img/akce-duo-jamaha/akce-duo-jamaha-2.jpg",
  "./img/akce-duo-jamaha/akce-duo-jamaha-8.jpg",
  "./img/akce-duo-jamaha/akce-duo-jamaha-1.jpg",
];

const FotogalerieAkceDuoJamaha: React.FC = () => {
  return (
    <>
      {/* ================= HEAD ================= */}
      <Helmet>
        <title>Akce Duo Jamaha | Hospůdka pod Rablinů</title>
        <meta
          name="description"
          content="Fotogalerie z akcí Duo Jamaha v Hospůdce pod Rablinů."
        />
      </Helmet>

      {/* ================= NAVBAR (IZOLOVANÝ) ================= */}
      <div className="relative z-50 isolate">
        <Navbar />
      </div>

      {/* ================= OBSAH ================= */}
      <main className="bg-[#F5E7CC] text-[#32180d] overflow-x-hidden">

        {/* ================= NADPIS ================= */}
        <section className="bg-white py-20 text-center">
          <h1 className="text-3xl md:text-4xl font-bold font-serif">
            AKCE DUO JAMAHA
          </h1>
        </section>

        {/* ================= GALERIE ================= */}
        <section className="max-w-7xl mx-auto px-6 py-20">
          <div
            className="
              grid
              grid-cols-1
              sm:grid-cols-2
              lg:grid-cols-3
              gap-6
            "
          >
            {images.map((src, i) => (
              <img
                key={i}
                src={src}
                alt={`Akce Duo Jamaha ${i + 1}`}
                className="
                  w-full
                  h-64
                  object-cover
                  rounded-xl
                  shadow-md
                  hover:scale-[1.02]
                  transition-transform
                  duration-300
                "
              />
            ))}
          </div>
        </section>

        {/* ================= FOOTER (ABSOLUTNÍ RESET) ================= */}
        <div className="[all:unset] block">
          <Footer />
        </div>

      </main>
    </>
  );
};

export default FotogalerieAkceDuoJamaha;